import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import './styles.scss'
import Heading from '../heading/Heading';
import UploadDragDropFiles from '../upload-drag-drop-files/UploadDragDropFiles';
import validateFile from '../../services/validateFile';
import FileList from '../file-list/FileList';
import Textarea from '../form/inputs/Textarea';
import CheckboxRadio from '../form/checkbox/CheckboxRadio';
import Text from '../text/Text';
import Input from '../form/inputs/Input';
import Checkbox from '../form/checkbox/Checkbox';
import { authorizedPersons } from '../../reducers/SecondStep';
import getDataByPostalCode from '../../services/getDataByPostalCode';
import ModalDocuments from '../static-modals/ModalDocuments';

const Attachments = ( props ) => {
    let [ load, setLoad ]             = useState(false);
    let [ buttonError, setButtonError ]             = useState(false);
    let [ openedModal, setOpenedModal ]             = useState(false);

    let [ buttonText, setButtonText ]               = useState("Przeciągnij plik / Wczytaj z dysku");
    let [ update, setUpdate ]                       = useState(0);
    let [ updateArray, setUpdateArray ]             = useState(0);
    let [ customerEmail, setCustomerEmail ]         = useState('');

    const dispatch                        = useDispatch()
    let attachmentsFiles                  = useSelector(state => state.attachmentsFiles)
    let comments                          = useSelector(state => state.comments)
    let postman                           = useSelector(state => state.postman)
    let courier                           = useSelector(state => state.courier)
    let productPrice                      = useSelector(state => state.productPrice)
    let showEsign                         = useSelector(state => state.showEsign)
    let showEsignMaxPrice                 = useSelector(state => state.showEsignMaxPrice)
    let esign                             = useSelector(state => state.esign)
    let esignForceVisible                 = useSelector(state => state.esignForceVisible)
    let authorizedPersons                 = useSelector(state => state.authorizedPersons)
    let esignPersons                      = useSelector(state => state.esignPersons)
    let email                             = useSelector(state => state.email)   
    let phone                             = useSelector(state => state.phone)   
    let realEstatesFiles                  = useSelector(state => state.realEstatesFiles);
    let fundsFiles                        = useSelector(state => state.fundsFiles);
    let otherCreditsFiles                 = useSelector(state => state.otherCreditsFiles);
    let fvFile                            = useSelector(state => state.fvFile);
    let providerPostal                    = useSelector(state => state.providerPostal);
    
      useEffect(() => {
        
        if ( !load ) {
            dispatch({ type: 'ESIGN_PERSONS_CHANGE', value: authorizedPersons }) 
            checkPostalCode();
            setLoad(true)
        }

    }, [ load ]);

      useEffect(() => {
          setUpdate(update + 1);
      }, [attachmentsFiles]);

      useEffect(() => {
          if ( esign || esignForceVisible ) {
            if (    esignPersons[0]['name'].length === 0 || 
                    esignPersons[0]['surname'].length === 0  ||
                    esignPersons[0]['phone'].length === 0  ||
                    esignPersons[0]['email'].length === 0 
                )  {
                    dispatch({ type: 'ESIGN_CHANGE', value: false })
                } else {
                    dispatch({ type: 'ESIGN_CHANGE', value: true })
                }
          }
            
      }, [updateArray])

      let setFiles = (val) => {
        let files = attachmentsFiles;
        for (let i = 0; i < val.length; i++) {
            const el = val[i];
            let validate = validateFile(1048576, 3, files.length, el);
            setButtonError( validate.error )
            setButtonText( validate.message )
            if ( !validate.error ) {
              files.push(el);
            }
        }          
        dispatch({ type: 'ATTACHMENTS_FILES_CHANGE', value: files })
        setUpdate(++update);
    }
      let removeFile = ( index ) => {
            let files = attachmentsFiles;
            files.splice( index, 1);   
            dispatch({ type: 'ATTACHMENTS_FILES_CHANGE', value: files })
            setUpdate(--update);
            setButtonError( false )
            setButtonText( 'Przeciągnij plik / <br /> Wczytaj z dysku' )
    }

    let updateValue =  async( val, index, property ) => {
        let copyArray = esignPersons;
         copyArray[index][property] = val;
        dispatch({ type: 'ESIGN_PERSONS_CHANGE', value: copyArray })
        await setUpdateArray(++updateArray);
    }

    let changeEsign = ( val ) => {
        dispatch({ type: 'ESIGN_CHANGE', value: val })
        dispatch({ type: 'ESIGN_FORCEVISIBLE_CHANGE', value: val })
    }

    let checkPostalCode = async () => {
        let data = await getDataByPostalCode(providerPostal);
        // console.log(data)
        if ( data.status == 'done' ) {
            setCustomerEmail(data.email);
        } else {
            setCustomerEmail('service@grenke.pl');
        }
    }

    let GetTextAttachments = () =>  {
    
        return (
            <div className='text-attachments'>
                <div class="heading  small-bigger">
                    <h2> Załącz lub prześlij niezwłocznie na adres: <a href={`email: ${ customerEmail }`} className="link">{ customerEmail }</a></h2>
                </div>
                <p className='list-text'>
                
                    <ul>
                        <li>Fakturę proforma, ofertę lub zamówienie od Dostawcy</li>
                        {/* { productPrice > 50000 &&
                            // <li>Skan podpisanego wniosku, który zostanie pobrany na Twój komputer po złożeniu wniosku</li>
                            <li>Mail z dodatkowymi informacjami finansowymi, który otrzymasz na swój adres email</li>
                        } */}
                        {/* { productPrice > 100000 && */}
                        { productPrice > 200000.00 &&
                            <li>Dokumenty finansowe za rok bieżący oraz { new Date().getFullYear() - 1 } i { new Date().getFullYear() - 2 } <a onClick={ () => setOpenedModal(true) }><span>//</span>Wykaz dokumentów</a></li>
                        }
                    </ul>
                </p>
            </div>
        ) 
    }

    let oldFiles=[  ...fvFile, 
                    ...realEstatesFiles,
                    ...fundsFiles,
                    ...otherCreditsFiles
    ]

    return (
        <>
        { openedModal &&
            <ModalDocuments closeModal={ () => setOpenedModal(false) } />
        }
        <div className="attachments">
            {/* <Heading title="E-faktury" medium />

            <Heading title="Adres e-mail w przypadku faktur dostarczanych drogą elektroniczną." small verySmallBottomMargin />
            <Text text="Wypełnienie pola oznacza zgodę na otrzymywanie faktur drogą elektroniczną na zasadach wskazanych w Regulaminie e-faktur, patrz <a href='https://media.grenke.com/download/downloadgateway.dll/getfile?p_inst_id=32279944&p_session_id=&p_obt_id=3477865&p_spec_id=1' target='_blank'>TUTAJ."/>
            <Input  name="email"
                    id="facture-email"
                    required={ false }
                    setFunction={ val => dispatch({ type: 'EMAILBILL_CHANGE', value: val }) }
                    type="text"
                    placehold={ "Adres e-mail" }
                    val={ emailbill }
                    size="xxl" 
                    regExp={/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,6})+$/}
                    allowChars={/.*
                    minChar={ 1 } 
                    forceValidate={ props.forceValidate } /> */}

            {/* Used empty for space */}
            <Text text=""/> 
            
            { showEsign && productPrice <= showEsignMaxPrice &&
            
            // { showEsign &&

                <>
                    <Heading title="E-PODPIS" medium />
                    <Heading title="Zdalne podpisanie umowy" small verySmallBottomMargin />
                    <Checkbox  required={ false } 
                            id="e-sign"
                            setFunction={ (val) => changeEsign(val) }
                            val={ esign }
                            forceValidate={ props.forceValidate }
                            text="Wyrażam zgodę na podpisanie umowy drogą elektroniczną na platformie Autenti." />
                    <Text text=""/> 
                    { esignForceVisible &&
                        <>
                            <Text class="small-font" text="W imieniu podmiotu wnioskującego o leasing - niniejszym dobrowolnie wyrażam zgodę na przekazanie przez Grenkeleasing 	sp. z o.o. moich danych osobowych (imię i nazwisko / numer telefonu / e-mail) do Autenti sp. z o.o. z siedzibą w Poznaniu 	(KRS: 0000436998; NIP 7831693251; e-mail: iod@autenti.com), celem kontaktu przez ww. podmiot dla zaoferowania mi 	usługi podpisu elektronicznego na potrzeby zawarcia umowy leasingowej z Grenkeleasing sp. z o.o."/>
                            <div className="inputs">
                                    {  updateArray >= 0 && authorizedPersons && authorizedPersons.map( ( item, index ) => (
                                        <div className="inputs-row">
                                        
                                            < Input
                                                    id={"name-" + index}
                                                    name={"name-" + index}
                                                    required={ false }
                                                    setFunction={ val => { updateValue(val, index, 'name'); } }
                                                    type="text"
                                                    placehold={ "Imię" }
                                                    val={ item.name }
                                                    size="xxl" 
                                                    regExp={ null }
                                                    minChar={ 1 } 
                                                    forceValidate={ props.forceValidate }
                                                    index={ index } 
                                                    disabled={ true }
                                                    activeInput={ true}
                                                    checkEsign />

                                            < Input
                                                    id={"surname-" + index}
                                                    name={"surname-" + index}
                                                    required={ false }
                                                    setFunction={ val => { updateValue(val, index, 'surname'); } }
                                                    type="text"
                                                    placehold={ "Nazwisko" }
                                                    val={ item.surname }
                                                    size="xxl" 
                                                    regExp={ null }
                                                    minChar={ 1 } 
                                                    checkEsign
                                                    disabled={ true }
                                                    activeInput={ true}
                                                    index={ index } 
                                                    forceValidate={ props.forceValidate }/>

                                            <Input  id={"email-" + index }
                                                    name={"email-" + index }
                                                    required={ (esign && index === 0) ? true : false  }
                                                    setFunction={ val => { updateValue(val, index, 'email'); } }
                                                    type="text"
                                                    placehold={ "Adres e-mail" }
                                                    val={ index === 0 ? email : item.email }
                                                    size="xxl" 
                                                    regExp={/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/}
                                                    allowChars={/.*/}
                                                    minChar={ 1 } 
                                                    checkEsign
                                                    index={ index } 
                                                    forceValidate={ props.forceValidate } />

                                            <Input  id={"phone-" + index }
                                                    name={"phone-" + index }
                                                    required={ (esign && index === 0) ? true : false }
                                                    setFunction={ val => { updateValue(val, index, 'phone'); } }
                                                    type="text"
                                                    placehold={ "Telefon" }
                                                    val={ index === 0 ? phone : item.phone }
                                                    size="xxl" 
                                                    regExp={/^[+0-9]{9,13}$/}
                                                    allowChars={/^[+0-9]{0,13}$/}
                                                    minChar={ 1 } 
                                                    checkEsign
                                                    index={ index } 
                                                    forceValidate={ props.forceValidate }/>

                                        </div>
                                    ) )}
                                
                            </div>
                            <Text class="small-font" text="Wyrażając zgodę potwierdzasz, że jako właściciel i użytkownik adresu e-mail z którego udzielasz zgody, jesteś wnioskującym 	(ew. umocowanym reprezentantem wnioskującego) o produkty oferowane przez Grenkeleasing sp. z o.o. zgodnie ze złożonym 	wnioskiem. Masz prawo do cofnięcia zgody w dowolnym momencie bez wpływu na zgodność z prawem przetwarzania, którego 	dokonano na podstawie zgody przed jej cofnięciem. Cofnięcia zgody można dokonać poprzez wysłanie informacji na 	adres e-mail: <a href='mailto:ochronadanych@grenke.pl'> ochronadanych@grenke.pl.</a> Szczegółowe informacje o przetwarzaniu danych osobowych są dostępne <a href='https://www.grenke.pl/ochrona-danych-leasing/#klient' target='_blank'><strong>tutaj.</strong><a/>"/>
                        </>
                    }
                </>
            }
            
            

            
            <Heading title="Załączniki" medium />
            <GetTextAttachments />

            <div className="row">
                { update && update >= 0 &&
                    <UploadDragDropFiles setFunction={ ( val ) => setFiles(val)  }
                        buttonText={ buttonText }
                        error={ buttonError } 
                        update={update}
                        tip={ true } 
                        tipHeader="Wczytaj plik"
                        tipText="Dodaj załącznik w formacie .jpg lub .pdf, w szczególności: <br />- ofertę GRENKE, jeżeli została wcześniej przygotowana, <br />- fakturę proforma lub zamówienie od wybranego Dostawcy. <br/> Waga pojedynczego pliku nie może być większa niż 1MB. W całym formularzu można załączyć max. 10 plików." /> 
                }
                { ( (attachmentsFiles.length > 0) || (oldFiles.length > 0) ) &&
                    <FileList   update={ update } 
                                files={ attachmentsFiles }
                                lastStep
                                oldFiles={ oldFiles }
                                remove={ ( val ) => removeFile( val ) } />
                }
                <Textarea   required={ false }
                            id="comments"
                            setFunction={ val => dispatch({ type: 'COMMENTS_CHANGE', value: val }) }
                            type="text"
                            placehold={ "Uwagi" }
                            val={ comments }
                            size="full" 
                            minChar={ 0 }
                            small={true}
                            maxChar={ 500 } 
                            regExp={/^.{0,500}$/}
                            allowChars={/^.{0,500}$/}
                            forceValidate={ props.forceValidate }
                            forceValidateItems={ props.forceValidateItems } />

                {/* <div className="postman">
                    { courier && 
                        <>
                            < Heading title="Czy chcesz, aby kurier odebrał od Ciebie podpisaną umowę?" small />
                            <div className="choose">
                                <CheckboxRadio   required={ false } 
                                                setFunction={ (val) =>  dispatch({ type: 'POSTMAN_CHANGE', value: val })}
                                                forceValidate={ props.forceValidate }
                                                val={ postman }
                                                text="Tak" />

                                <CheckboxRadio   required={ false } 
                                                setFunction={ (val) =>  dispatch({ type: 'POSTMAN_CHANGE', value: val })}
                                                forceValidate={ props.forceValidate }
                                                text="Nie" 
                                                val={ postman } />
                            </div>
                        </>
                    }
                    
                </div> */}
            </div>
        </div>
        </>
    )
}

export default Attachments;